import { createFileRoute } from '@tanstack/react-router'

import { GoLiveRampUpScreen } from './-components/go-live-ramp-up-screen.tsx'

export const Route = createFileRoute('/business-performance/go-live-ramp-up')({
  component: GoLiveRampUpScreen
})
